/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getTrendingTopics.defs.js'
export * as $defs from './getTrendingTopics.defs.js'
